<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="os-xgrad" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stop-color="#1E70FF"/>
        <stop offset="100%" stop-color="#00CFFF"/>
      </linearGradient>
    </defs>
    <rect width="100" height="100" rx="22" fill="#071235"/>
    <path d="M26 26 L74 74" stroke="url(#os-xgrad)" stroke-width="9.5" stroke-linecap="round"/>
    <path d="M74 26 L26 74" stroke="url(#os-xgrad)" stroke-width="9.5" stroke-linecap="round"/>
    <circle cx="50" cy="50" r="6.5" fill="#00CFFF" opacity="0.95"/>
    <circle cx="50" cy="50" r="3" fill="white" opacity="0.9"/>
  </svg>
</template>
